module.exports = __webpack_public_path__ + "static/img/form.f3ed6fee.svg";